const localFun = {
  // get方法，用于从localStorage中获取数据
  get: function (key) {
    return localStorage.getItem(key) || null;
  },

  // set方法，用于向localStorage中存储数据
  set: function (key, value) {
    localStorage.setItem(key, value);
  },

  // remove方法，用于从localStorage中删除数据
  remove: function (key) {
    localStorage.removeItem(key);
  }
};

window.localFun = localFun;

export default localFun;
